/**
 * 10.9L1 — botão "🌐 Site oficial" (menu principal e pausa). Abre o site SEM tirar o jogador do
 * jogo: no APK (Capacitor) numa aba do navegador por cima do app (plugin Browser, o mesmo do login
 * com Google — dentro do WebView ele trocaria o jogo pela página); na web, numa aba nova.
 * 10.9L2 — BUG (Thiago: "tá abrindo o jogo"): /site no domínio do jogo era respondido com o JOGO
 * pelo service worker antigo de quem já jogou no navegador (a aba do APK usa o Chrome, que tem esse
 * SW). Agora abre o endereço PRÓPRIO do site, que nunca tem service worker.
 */
const SITE_URL = "https://site.void-hunter.pages.dev/";

function temBrowserNativo(): boolean {
  const c = (window as unknown as { Capacitor?: { isPluginAvailable?: (n: string) => boolean } }).Capacitor;
  try {
    return typeof c?.isPluginAvailable === "function" ? c.isPluginAvailable("Browser") : false;
  } catch {
    return false;
  }
}

export async function openSite(): Promise<void> {
  if (temBrowserNativo()) {
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url: SITE_URL, presentationStyle: "popover" });
      return;
    } catch { /* cai pro jeito da web */ }
  }
  // web: o endereço próprio do site (no dev, a página local /site.html)
  window.open(import.meta.env.DEV ? `${location.origin}/site.html` : SITE_URL, "_blank", "noopener");
}
